import { NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import confetti, { Shape } from 'canvas-confetti';
import { materialModules } from 'src/shared/material.module';
import { globalWindow } from 'src/shared/window-globals';

const defaultShots: ParticleShot[] = [
  {
    particleRatio: 0.25,
    options: {
      spread: 26,
      startVelocity: 55,
      gravity: 0.85,
    },
  },
  {
    particleRatio: 0.2,
    options: {
      spread: 60,
      gravity: 0.7,
    },
  },
  {
    particleRatio: 0.35,
    options: {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
      gravity: 0.8,
    },
  },
  {
    particleRatio: 0.1,
    options: {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
      gravity: 0.7,
    },
  },
  {
    particleRatio: 0.1,
    options: {
      spread: 120,
      startVelocity: 45,
      gravity: 0.8,
    },
  },
];

@Component({
  selector: 'ez-celebration',
  imports: [
    materialModules,
    NgOptimizedImage,
  ],
  templateUrl: './celebration.component.html',
  styleUrl: './celebration.component.scss',
  host: {
    '[class.celebration]': 'true',
  },
})
export class CelebrationComponent implements OnInit {
  readonly starImage = globalWindow.UrlResolver.MrFive('assets/svgs/celebration-star.svg');

  protected readonly snackBarRef = inject(MatSnackBarRef);
  protected readonly celebrationConfig: CelebrationConfig = inject(MAT_SNACK_BAR_DATA);

  ngOnInit(): void {
    const shots = this.celebrationConfig.shots ?? defaultShots;
    shots.forEach((shot) => {
      this.shoot(shot.particleRatio, shot.options);
    });
  }

  shoot(particleRatio: number, options: object): void {
    confetti({
      disableForReducedMotion: true,
      origin: { y: 0.9 },
      ...options,
      particleCount: this.celebrationConfig.baseParticlesPerShot ?? Math.floor(200 * particleRatio),
      shapes: this.celebrationConfig.shapes ?? ['star'],
      colors: this.celebrationConfig.colors ?? ['#DA9EC7', '#CC202C', '#FDC20F', '#FDC20F', '#A62282'],
    });
  }
}

export interface CelebrationConfig {
  title: string;
  message: string;
  delay: number; // Delay in milliseconds before the confetti starts
  shapes: Shape[];
  colors: string[];
  shots: ParticleShot[];
  baseParticlesPerShot: number;
}

export interface ParticleShot {
  particleRatio: number;
  options: confetti.Options;
}
